import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/auth/actions.js'), 'auth/actions.js')
  resolveStoreModules(require('../store/auth/getters.js'), 'auth/getters.js')
  resolveStoreModules(require('../store/auth/mutations.js'), 'auth/mutations.js')
  resolveStoreModules(require('../store/auth/state.js'), 'auth/state.js')
  resolveStoreModules(require('../store/common/actions.js'), 'common/actions.js')
  resolveStoreModules(require('../store/common/getters.js'), 'common/getters.js')
  resolveStoreModules(require('../store/common/mutations.js'), 'common/mutations.js')
  resolveStoreModules(require('../store/common/state.js'), 'common/state.js')
  resolveStoreModules(require('../store/dict/actions.js'), 'dict/actions.js')
  resolveStoreModules(require('../store/dict/getters.js'), 'dict/getters.js')
  resolveStoreModules(require('../store/dict/mutations.js'), 'dict/mutations.js')
  resolveStoreModules(require('../store/dict/state.js'), 'dict/state.js')
  resolveStoreModules(require('../store/location/actions.js'), 'location/actions.js')
  resolveStoreModules(require('../store/location/getters.js'), 'location/getters.js')
  resolveStoreModules(require('../store/location/mutations.js'), 'location/mutations.js')
  resolveStoreModules(require('../store/location/state.js'), 'location/state.js')
  resolveStoreModules(require('../store/public/actions.js'), 'public/actions.js')
  resolveStoreModules(require('../store/public/getters.js'), 'public/getters.js')
  resolveStoreModules(require('../store/public/mutations.js'), 'public/mutations.js')
  resolveStoreModules(require('../store/public/state.js'), 'public/state.js')
  resolveStoreModules(require('../store/search/actions.js'), 'search/actions.js')
  resolveStoreModules(require('../store/search/getters.js'), 'search/getters.js')
  resolveStoreModules(require('../store/search/mutations.js'), 'search/mutations.js')
  resolveStoreModules(require('../store/search/state.js'), 'search/state.js')
  resolveStoreModules(require('../store/seo/actions.js'), 'seo/actions.js')
  resolveStoreModules(require('../store/seo/getters.js'), 'seo/getters.js')
  resolveStoreModules(require('../store/seo/mutations.js'), 'seo/mutations.js')
  resolveStoreModules(require('../store/seo/state.js'), 'seo/state.js')
  resolveStoreModules(require('../store/sports/actions.js'), 'sports/actions.js')
  resolveStoreModules(require('../store/sports/getters.js'), 'sports/getters.js')
  resolveStoreModules(require('../store/sports/mutations.js'), 'sports/mutations.js')
  resolveStoreModules(require('../store/sports/state.js'), 'sports/state.js')
  resolveStoreModules(require('../store/user/actions.js'), 'user/actions.js')
  resolveStoreModules(require('../store/user/getters.js'), 'user/getters.js')
  resolveStoreModules(require('../store/user/mutations.js'), 'user/mutations.js')
  resolveStoreModules(require('../store/user/state.js'), 'user/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
